import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function FacebookPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        // silent
      }
      return;
    }
    try {
      // Standard Meta Pixel base code
      ;
      (function (f: any, b: Document, e: string, v: string) {
        let n: any;
        let t: HTMLScriptElement;
        let s: HTMLScriptElement;
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
        s.parentNode?.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      // silent — never break the page if pixel fails to load
    }
  }, []);
  return <noscript data-id="element-12">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-13" />
    </noscript>;
}